"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const styles_1 = __importDefault(require("../../styles"));
const Button_1 = __importDefault(require("../Button"));
exports.default = (0, mobx_react_1.observer)(({ field, controls = null }) => (react_1.default.createElement("span", null,
    (!controls || controls.onSubmit) &&
        react_1.default.createElement(Button_1.default, { type: "submit", className: styles_1.default.ctrl, onClick: field.onSubmit, disabled: field.submitting, content: (field.submitting || field.validating)
                ? react_1.default.createElement("b", null,
                    react_1.default.createElement("i", { className: "fa fa-spinner fa-spin" }))
                : react_1.default.createElement("b", null,
                    react_1.default.createElement("i", { className: "fa fa-dot-circle-o" }),
                    " Submit") }),
    (!controls || controls.onAdd) &&
        react_1.default.createElement(Button_1.default, { onlyIcon: true, text: 'Add', type: "button", icon: "plus-circle", label: field.label, onClick: field.onAdd, className: styles_1.default.fctrl }),
    (!controls || controls.onDel) &&
        react_1.default.createElement(Button_1.default, { onlyIcon: true, text: 'Delete', type: "button", icon: "times-circle", label: field.label, onClick: field.onDel, className: styles_1.default.fctrl }),
    (!controls || controls.onClear) &&
        react_1.default.createElement(Button_1.default, { onlyIcon: true, text: 'Clear', type: "button", icon: "eraser", label: field.label, onClick: field.onClear, className: styles_1.default.fctrl }),
    (!controls || controls.onReset) &&
        react_1.default.createElement(Button_1.default, { onlyIcon: true, text: 'Reset', type: "button", icon: "refresh", label: field.label, onClick: field.onReset, className: styles_1.default.fctrl }))));
